module.exports = {
  policyTypes: { Home: 'H', Auto: 'A', ARBundle: 'AR', HABundle: 'HA', Renters: 'R' }
};
